<template>
    <div>
        <v-container max-width="2500" style="max-width: 3000px !important">
            <v-card class="mx-auto my-5" max-width="2500">
                <v-system-bar class="py-5 px-3" color="#1973a5" style="color: #fff" dark>
                    Formulario bloqueo paciente</v-system-bar>
            </v-card>
            <v-card class="mx-auto my-5 elevation-1" max-width="2100">
                <v-row>
                    <v-col cols="12" sm="6" md="3">
                        <v-text-field max-width="200" class="mx-3" v-model="searchNombre" label="Nombre"
                            prepend-inner-icon="mdi-magnify" variant="outlined" hide-details single-line
                            @input="dataInit"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-text-field max-width="200" class="mx-3" v-model="searchDocumento" label="Número Doc."
                            prepend-inner-icon="mdi-magnify" variant="outlined" hide-details single-line
                            @input="dataInit"></v-text-field>
                    </v-col>
                </v-row>
            </v-card>
            <v-card class="mx-auto my-5" max-width="2500">
                <div style="max-height: 70vh; overflow-y: scroll">
                    <v-data-table :headers="headers" :items="filteredData" class="elevation-1" :sort-by.sync="sortBy"
                        :loading="isLoading" loading-text="Cargando... Por favor espere">
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-checkbox style="margin: 0;" v-model="item.estado"
                                @click="loadEstado(item.estado, item.url)">
                            </v-checkbox>
                        </template>
                    </v-data-table>
                </div>
            </v-card>
            <v-dialog v-model="dialogLoader" hide-overlay persistent width="300" class="fondo-griss">
                <v-card color="primary" dark>
                    <v-card-text>
                        Cargando Datos
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-container>
    </div>
</template>
<style>
td {
    white-space: nowrap;
}

.bg-primary-table {
    /* background: rgb(27 160 255 / 12%); */
    font-weight: 400;
}

.text-start {
    font-size: 0.8rem !important;
}

.container {
    max-width: 3000px !important;
}
</style>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Swal from "sweetalert2";

export default {
    data() {
        return {
            dialogLoader: false,
            polygonOptions: {
                strokeColor: '#FF0000', // Color del borde
                strokeOpacity: 0.1,     // Opacidad del borde
                strokeWeight: 0.1,        // Grosor del borde
                fillColor: '#FF0000',   // Color de relleno
                fillOpacity: 0.35       // Opacidad de relleno
            },
            marcadores: [
                {
                    posicion: { lat: -12.074928851253814, lng: -77.04316187097396 },
                    nombre_completo: 'Ubique al \\n paciente'
                },
            ],
            e1: 1,
            step: 1,
            itemsUbigeo: [],
            itemsDepartamento: [],
            itemsDistrito: [],
            itemsProvincia: [],
            dataHospital: [],
            dataMedico: [],
            dialogAsignarCupo: false,
            dialogCargaMasiva: false,
            valor1: 15,
            valor2: 10,
            ver: false,
            searchDocumento: "",
            searchNombre: "",
            dataPaciente: [],
            dataEnvio: {
                fecha: null,
            },
            titleButton: "",
            titleCard: "",
            valid: true,
            pacienteData: {
                tipo_doc: null,
                num_doc: null,
                nombres: null,
                ape_pat: null,
                ape_mat: null,
                fecha_nac: null,
                cas: null,
                estado: 1,
                sexo: null,
                cordePacForm: null,
                latitud: null,
                longitud: null,
                direccion: null,
                distrito: null,
                user_id: null,
                cordePac: null,
                telefono: null,
                telefonoAlterno: null,
                departamento: null,
                provincia: null,
                ubigeo_id: null,
                medico_id: null,
                hospital_id: null,
                fecha_ultima_dialisis: null,
                serologia: null,
                pacienteId: null
            },
            cas: null,
            maestro: null,
            deleteUser: [],
            statusEdit: false,
            date: new Date()
                .toISOString()
                .substr(0, 10),
            date1: new Date()
                .toISOString()
                .substr(0, 10),
            search: "",
            sortBy: [{ key: "cupos_disponible", order: "asc" }],
            headers: [
                { text: "Nombre", value: "nombres" },
                { text: "Ape. Paterno", value: "ape_pat" },
                { text: "Ape. Materno", value: "ape_mat" },
                { text: "Fec. Nac.", value: "fecha_nac" },
                { text: "Clínica", value: "descripCas" },
                { text: "Sexo", value: "genero" },
                { text: "Tipo Doc", value: "descripMaestro" },
                { text: "Num. Doc", value: "num_doc" },
                { text: "Hospital", value: "hospital" },
                { text: "Medico", value: "medico" },
                { text: "Serología", value: "serologia" },
                { text: "Distrito", value: "distritoDescrip" },
                { text: "Actions", align: "center", value: "actions", sortable: false },
            ],
            dialogEdit: false,
            dialogDelete: false,
            dataCas: [],
            dataMaesto: [],
            isLoading: false,
            itemsTipSex: ["MASCULINO", "FEMENINO"],
            menu: false,
            menu1: false,
            date: new Date().toISOString().substr(0, 10),
            itemsPacientes: [],
            arraySerologia: [{ value: "positivo", label: "Positivo" }, { value: "negativo", label: "Negativo" }],
            pacienteRegistrado: [],
            idItem: null,
            idPacienteActual: null
        };

    },
    methods: {
        loadEstado(status, idPaciente) {
            let statusPaciente = status ? "1" : "2";
            this.idPacienteActual = idPaciente;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .patch(RUTA_API + "/paciente/" + this.idPacienteActual.split("/")[4] + "/",
                            {
                                /* id_parameCentroPuesto: idCupo, */
                                estado: statusPaciente
                            },
                            {
                                headers: { Authorization: this.auth },
                            })
                        .then((res) => {
                            this.dialogLoader = false;
                            /* this.desserts=res.data; */
                        })
                        .catch((res) => {
                            this.dialogLoader = false;
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        dataInit() {
            this.isLoading = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/pacienteIndex/?num_doc=" + this.searchDocumento + "&nombre=" + this.searchNombre, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.isLoading = false;
                            this.dataPaciente = res.data;
                            this.dataPaciente.forEach((item) => {
                                // Calcula el nombre completo y guárdalo en una nueva propiedad 'nombreCompleto'
                                item.descripCas = item.datosCasOri ? `${item.datosCasOri.descripCas}` : ``;
                                item.descripMaestro = `${item.datosMaestro.descripMaestro}`;
                                item.medico = `${item.datosMedico ? item.datosMedico.nombre : ""}`;
                                item.hospital = `${item.datosHospital ? item.datosHospital.hospital : ""}`;
                                item.distritoDescrip = `${item.datosUbigeo ? item.datosUbigeo.distrito : ""}`;
                                item.genero = `${item.sexo == "F" || item.sexo == "FEMENINO" ? "F" : "M"}`;
                                item.estado = item.estado == "1" ? true : false;
                            });
                        })
                        .catch((res) => {
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        clearForm() {
            this.pacienteData = {
                tipo_doc: null,
                num_doc: null,
                nombres: null,
                ape_pat: null,
                ape_mat: null,
                fecha_nac: null,
                cas: null,
                estado: 1,
                sexo: null,
                cordePac: null,
                latitud: null,
                longitud: null,
                direccion: null,
                distrito: null,
                user_id: null,
                telefonoAlterno: null,
                telefono: null,
                ubigeo_id: null,
                medico_id: null,
                hospital_id: null,
                serologia: null
            };
            this.date = null;
            this.cas = null;
            this.maestro = null;
        },
    },
    mounted() { },
    computed: {
        filteredData() {
            if (!this.searchNombre && !this.searchDocumento) {
                return this.dataPaciente;
            }
            let filtered = this.dataPaciente;
            if (this.searchNombre) {
                filtered = filtered.filter((item) => {
                    const nombreCompleto = `${item.nombres} ${item.ape_pat} ${item.ape_mat}`;
                    return nombreCompleto.toLowerCase().includes(this.searchNombre.toLowerCase());
                });
            }
            if (this.searchDocumento) {
                filtered = filtered.filter((item) =>
                    item.num_doc
                        .toLowerCase()
                        .includes(this.searchDocumento.toLowerCase())
                );
            }
            return filtered;
        },
    },
    created() {
        this.dataInit();
    },
    components: {
    },
};
</script>